export default __webpack_public_path__ + "static/team-hands-6951bbe81e07b8dd281921946b39731c.jpg";